module.exports = __webpack_public_path__ + "static/vet-banner-285b1ff9b4e5e9c936660e55da50866c.jpg";